<!--
  A card of its own (#6676): it wraps a cs-card and registers itself as one, so a host puts it
  straight into its cs-card-list beside its other cards, never inside one of them.

  Next week's intake (#5456 review round): what the person ate and what the app recommends. The
  host's radio rows go in the slot under them, drawn as the intake form draws its choices; the card
  has no buttons, because the page's bar holds Back and Confirm.
-->
<cs-card>
  <cs-card-title>
    {{ LL.nextIntake.title() }}
    @if (nowText) {
      <cs-badge title-action color="gray" class="now-pill" [attr.data-kcal]="roundedNowKcal" [label]="nowText"></cs-badge>
    }
    @if (nowSourceLine) {
      <cs-note class="now-source">{{ nowSourceLine }}</cs-note>
    }
  </cs-card-title>
  <cs-card-content>
    @if (recommendedText) {
      <div class="recommended" [attr.data-kcal]="roundedRecommendedKcal">{{ recommendedText }}</div>
    }
    <div class="answers">
      <ng-content></ng-content>
    </div>
  </cs-card-content>
</cs-card>
